import React from 'react';
import {MDBContainer,} from "mdb-react-ui-kit";
import "../css/servicesfont.css";
const StartPractice = () => {
    return (
        <MDBContainer fluid className="p-0">
        <div className="container py-5">
            <div className="row">
              <div className="col-12">
                  <div className="section-title mb-4 pb-2">
                      <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{fontFamily:'Lora, serif'}}> Set Up a Practice </h1>
                      <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify' }}>
                       Launching a new medical practice? <b>AcerHealth </b>provides complete support to help healthcare providers establish and grow successful
                        practices. From <b>provider credentialing </b>and <b>medical billing services </b>to <b>EMR billing integration </b>and 
                        <a
                            href="https://acerhealth.com/services/revenue-cycle-management"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
               revenue cycle management, 
                        </a>  
                       
                        we ensure your operations run smoothly from day one.</p>
                          <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify' }}>
                     Starting a practice is about more than just clinical expertise—it requires business insight, compliance with payer regulations, and efficient financial processes.    Our 
                        <a
                            href="https://acerhealth.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                  U.S.-based medical billing company
                        </a>  
                       
                   understands the challenges new providers face, especially when it comes to reducing <b>claim 
                        denials </b>and improving <b>cash flow.</b></p>
                          <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify' }}>
                    With our 
                        <a
                            href="https://acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                affordable medical billing services
                        </a>  
                       
                   and  expert
                   <a
                            href="https://acerhealth.com/services/denial-management-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                denial management,
                        </a>   you gain a trusted partner that helps you avoid revenue leakage and maximize profitability. Whether you're opening a <b>solo practice, </b>
                group clinic, or specialty care center, AcerHealth offers tailored solutions that help you thrive in today’s evolving healthcare landscape.
                   </p>
                  </div>
              </div>
          </div>
        </div>    
        </MDBContainer>
    );
};
export default StartPractice;



